module.exports = __webpack_public_path__ + "static/img/1.d74a326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/1.jpg
// module id = Ghby
// module chunks = 0